// extracted by mini-css-extract-plugin
module.exports = {"MenuButton":"MenuButton_MenuButton__3lo8_","MenuButtonActive":"MenuButton_MenuButtonActive__1arLo"};